import { BlazonHexagonBorder } from 'app/common/blazon/hexagon-border'
import React from 'react'
import { HexagonBorder } from 'app/assets/icons/HexagonBorder'
import { colors } from 'shared/assets/styles'
import styled from 'styled-components'

const { yellow, yellow3 } = colors

type sizeVariants = 'small' | 'medium' | 'big'

type Props = {
    imageUrl: string,
    size?: sizeVariants
}

const BlazonSticker = (props: Props) => {
    const { imageUrl, size = 'medium' } = props

    return (
        <Root size={size}>
            <HexagonBorder />
            <ImageContainer>
                <BlazonHexagonBorder src={imageUrl} />
            </ImageContainer>
        </Root>
    )
}

const Root = styled.div`
    position: relative;
    width: fit-content;
    ${({ size }) =>
        size === 'small' &&
        `
                height: 32px;
                padding-top: 8px;
    `};
    ${({ size }) =>
        size === 'medium' &&
        `
                height: 106px;
                padding-top: 24px;
    `};
    ${({ size }) =>
        size === 'big' &&
        `
                height: 152px;
                padding-top: 40px;
    `};
    background: linear-gradient(
        0deg,
        transparent 58%,
        ${yellow} 58%,
        ${yellow3} 100%
    );
`

const ImageContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: inherit;
    padding-top: inherit;
`

export default BlazonSticker
